import iframeResize from '@iframe-resizer/parent'

window.iframeResize = iframeResize
